import svgUrl from "ni:svgr;6m6FpM7qnscNstz9p6rlutUIT9jJmtMvVN_tmRJmyAA";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const SvgChevron = props => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M3.126 6.168a.5.5 0 0 1 .706-.042L8 9.831l4.168-3.705a.5.5 0 0 1 .664.748l-4.5 4a.5.5 0 0 1-.664 0l-4.5-4a.5.5 0 0 1-.042-.706Z" fill="currentColor" /></svg>;
const Memo = memo(SvgChevron);
export { Memo as ReactComponent };